module.exports = __webpack_public_path__ + "static/media/JRT_Photo.26669ffd.jpeg";